import React, { useEffect, useState } from 'react'
import share from '../../images/share-ios.svg'
import mailShare from '../../images/share-mail.svg'
import * as Styled from './SocialShare.styles'

const SocialShare = () => {
  const handleShare = (event) => {
    event.preventDefault()

    if (navigator.share) {
      navigator
        .share({
          title: document?.title,
          text: 'Check out this post:',
          url: window?.location?.href,
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing:', error)) // eslint-disable-line
    } else {
      // Fallback code for browsers that do not support navigator.share
      console.log('Sharing is not supported in this browser.') // eslint-disable-line
    }
  }

  const mailtoLink = `mailto:?subject=${encodeURIComponent(
    document?.title
  )}&body=${encodeURIComponent(
    `I thought you might find this interesting:\n${window?.location.href}`
  )}`

  return (
    <Styled.SocialShare>
      <button
        onClick={(event) => handleShare(event)}
        className="share"
        type="button"
      >
        <img src={share} alt="Share this page" />
      </button>
      <a className="mail" href={mailtoLink}>
        <img src={mailShare} alt="Share via Email" />
      </a>{' '}
    </Styled.SocialShare>
  )
}

const SocialShareWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <SocialShare {...props} />
}

export default SocialShareWrapper
